module.exports = __webpack_public_path__ + "img/placeholder-header.4c116853.png";